export const ADD_NEW_LABEL_SYMBOL = 'labelSymbolWizard/ADD_NEW_LABEL_SYMBOL';
export const REMOVE_LABEL_SYMBOL = 'labelSymbolWizard/REMOVE_LABEL_SYMBOL';
export const FIELD_EDITED = 'labelSymbolWizard/FIELD_EDITED';
export const UPDATE_LABEL_SYMBOL = 'labelSymbolWizard/UPDATE_LABEL_SYMBOL';
export const LOAD_LABEL_SYMBOL_DATA = 'labelSymbolWizard/LOAD_LABEL_SYMBOL_DATA';
export const MARK_AS_DELETED = 'labelSymbolWizard/MARK_AS_DELETED';
